import hours from './hours';
import modal from './modal';

const root = {
	hours,
	modal
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js